module.exports = __webpack_public_path__ + "static/media/letter.43325eca.svg";